import axios from 'axios';
import config from '@config';
import CTRestRequestFactory from '@core/utils/network/CTRestRequestFactory';
import RestRequestFactory from '@core/utils/network/RestRequestFactory';

export default class RestService {
    private readonly request: any;
    private readonly ctRequest: any;
    private readonly smdcRequest: any;

    constructor(
        restRequestFactories = {
            restRequestFactory: RestRequestFactory,
            ctRestRequestFactory: CTRestRequestFactory
        }
    ) {
        this.request = restRequestFactories.restRequestFactory.create(config.services.country.frontEndHost);
        this.ctRequest = restRequestFactories.ctRestRequestFactory.create(config.services.country.host, true);
    }

    /**
     * @throws {RequestError}
     */
    public getShops(): Promise<any> {
        return this.ctRequest({
            url: '/user/getClubs',
            method: 'get',
        });
    }

    /**
     * @throws {RequestError}
     */
    public getSmdcShops(): Promise<any> {
        return axios({
            url: `${config.services.smdc.host}/api/locations`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Authorization: config.services.smdc.authorizationKey,
            },
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/country/_private/RestService.ts